import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';

type Props = {
  className?: string;
  height?: number;
  title?: string;
  width?: number;
};

const SuccessFormIcon = ({
  className = '',
  height = 190,
  title,
  width = 200,
}: Props) => (
  <AccessibleSVG
    className={`success-form-icon ${className}`}
    height={height}
    title={title}
    viewBox="0 0 200 190"
    width={width}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M137.187 18.858c25.321 7.297 50.458 30.677 58.718 54.238 9.433 23.478.524 61.904-17.186 84.211-17.71 22.308-49.823 30.508-70.174 19.983-20.35-10.526-17.397-42.155-30.79-62.376C63.062 95.192 34.378 98.94 31 75.88c-3.38-23.06 14.18-40.828 34.581-49.885 19.116-8.347 45.474-15.784 71.606-7.137zM26.914 137.325c13.196 0 14.321 7.988 14.321 18.555 0 9.14-1.125 17.128-14.321 17.128C14.414 173.008 4 165.02 4 155.88c0-10.567 10.415-18.555 22.914-18.555z"
        fill="#E5EFFA"
        fillRule="nonzero"
      />
      <path
        d="M155.357 156.429a.44.44 0 0 1 .447.437v.576a.897.897 0 0 1 .326.326h.574c.215 0 .395.163.432.368l.007.078a.44.44 0 0 1-.438.447h-.575a.897.897 0 0 1-.325.326l-.001.575a.446.446 0 0 1-.369.43l-.078.008a.451.451 0 0 1-.446-.45v-.562a.897.897 0 0 1-.327-.326l-.575-.001a.446.446 0 0 1-.43-.368l-.008-.079c0-.246.207-.446.451-.446h.562a.897.897 0 0 1 .327-.327v-.573c0-.216.163-.395.368-.432l.078-.007zM70.786 170a.44.44 0 0 1 .446.438l.001.575a.897.897 0 0 1 .326.326h.573c.216 0 .395.164.432.368l.007.079a.44.44 0 0 1-.437.446l-.576.001a.897.897 0 0 1-.325.325v.576a.446.446 0 0 1-.369.43l-.078.007a.451.451 0 0 1-.447-.45v-.562a.897.897 0 0 1-.326-.326h-.575a.446.446 0 0 1-.43-.369l-.008-.078c0-.247.206-.447.45-.447h.562a.897.897 0 0 1 .327-.327v-.573c0-.215.164-.395.368-.432l.079-.007zM16.786 147a.44.44 0 0 1 .446.438l.001.575a.897.897 0 0 1 .326.326h.573c.216 0 .395.164.432.368l.007.079a.44.44 0 0 1-.437.446l-.576.001a.897.897 0 0 1-.325.325v.576a.446.446 0 0 1-.369.43l-.078.007a.451.451 0 0 1-.447-.45v-.562a.897.897 0 0 1-.326-.326h-.575a.446.446 0 0 1-.43-.369l-.008-.078c0-.247.206-.447.45-.447h.562a.897.897 0 0 1 .327-.327v-.573c0-.215.164-.395.368-.432l.079-.007zM64.786 44a.44.44 0 0 1 .446.438l.001.575a.897.897 0 0 1 .326.326h.573c.216 0 .395.164.432.368l.007.079a.44.44 0 0 1-.437.446l-.576.001a.897.897 0 0 1-.325.325v.576a.446.446 0 0 1-.369.43l-.078.007a.451.451 0 0 1-.447-.45v-.562a.897.897 0 0 1-.326-.326h-.575a.446.446 0 0 1-.43-.369L63 45.786c0-.247.206-.447.45-.447h.562a.897.897 0 0 1 .327-.327v-.573c0-.215.164-.395.368-.432l.079-.007zM18.075 147.5h0H15 18.075zM64.503 46.071h0-3.074 3.074zM172.143 182.916v-1.488c0-.394.317-.714.714-.714.395 0 .714.324.714.724v4.267c0 .4-.317.724-.714.724a.715.715 0 0 1-.714-.721v-2.792z"
        fill="#0061D5"
      />
      <path
        d="M174.99 182.857c.4 0 .724.317.724.714a.719.719 0 0 1-.723.715h-4.267a.717.717 0 0 1-.724-.715c0-.394.324-.714.724-.714h4.267z"
        fill="#0061D5"
      />
      <circle cx="172.857" cy="183.571" fill="#0061D5" r="1.429" />
      <path
        d="M85.218 176.786h0-3.075 3.075zM53.571 186.487V185c0-.394.317-.713.715-.713.394 0 .714.323.714.723v4.267c0 .4-.317.724-.714.724a.715.715 0 0 1-.715-.721v-2.792z"
        fill="#0061D5"
      />
      <path
        d="M56.42 186.429c.399 0 .723.317.723.714a.719.719 0 0 1-.724.714h-4.267a.717.717 0 0 1-.723-.714c0-.395.323-.714.723-.714h4.267z"
        fill="#0061D5"
      />
      <circle cx="54.286" cy="187.143" fill="#0061D5" r="1.429" />
      <path
        d="M25 14.344v-1.488c0-.394.317-.713.714-.713.395 0 .715.323.715.724v4.266c0 .4-.317.724-.715.724a.715.715 0 0 1-.714-.72v-2.793z"
        fill="#0061D5"
      />
      <rect
        fill="#0061D5"
        height="5.714"
        rx=".714"
        transform="rotate(90 25.714 15)"
        width="1.429"
        x="25"
        y="12.143"
      />
      <circle cx="25.714" cy="15" fill="#0061D5" r="1.429" />
      <path
        d="M169.286 17.916v-1.488c0-.394.317-.714.714-.714.394 0 .714.324.714.724v4.267c0 .4-.317.724-.714.724a.715.715 0 0 1-.714-.721v-2.792z"
        fill="#0061D5"
      />
      <path
        d="M172.133 17.857c.4 0 .724.317.724.714a.719.719 0 0 1-.724.715h-4.266a.717.717 0 0 1-.724-.715c0-.394.323-.714.724-.714h4.266z"
        fill="#0061D5"
      />
      <circle cx="170" cy="18.571" fill="#0061D5" r="1.429" />
      <path
        d="M196.429 143.63v-1.488c0-.394.317-.713.714-.713.394 0 .714.323.714.723v4.267c0 .4-.317.724-.714.724a.715.715 0 0 1-.714-.721v-2.792z"
        fill="#0061D5"
      />
      <path
        d="M199.276 143.571c.4 0 .724.317.724.715a.719.719 0 0 1-.724.714h-4.267a.717.717 0 0 1-.723-.714c0-.395.323-.715.723-.715h4.267z"
        fill="#0061D5"
      />
      <circle cx="197.143" cy="144.286" fill="#0061D5" r="1.429" />
      <path
        d="M2.143 121.487V120c0-.394.317-.713.714-.713.395 0 .714.323.714.723v4.267c0 .4-.317.724-.714.724a.715.715 0 0 1-.714-.721v-2.792z"
        fill="#0061D5"
      />
      <path
        d="M4.99 121.429c.4 0 .724.317.724.714a.719.719 0 0 1-.723.714H.724a.717.717 0 0 1-.724-.714c0-.395.324-.714.724-.714H4.99z"
        fill="#0061D5"
      />
      <circle cx="2.857" cy="122.143" fill="#0061D5" r="1.429" />
      <path
        d="M131.429 2.201V.713c0-.394.317-.713.714-.713.394 0 .714.324.714.724V4.99c0 .4-.317.723-.714.723a.715.715 0 0 1-.714-.72V2.2z"
        fill="#0061D5"
      />
      <path
        d="M134.276 2.143c.4 0 .724.317.724.714a.719.719 0 0 1-.724.714h-4.267a.717.717 0 0 1-.723-.714c0-.394.323-.714.723-.714h4.267z"
        fill="#0061D5"
      />
      <circle cx="132.143" cy="2.857" fill="#0061D5" r="1.429" />
      <path
        d="M129.003 129c5.428 0 9.845 4.325 9.993 9.72l.004.28c0 5.523-4.486 10-9.997 10H55.997C50.476 149 46 144.524 46 139c0-5.523 4.486-10 9.997-10h73.006zm-68.784 6.375l-4.131 5.164-2.412-2.214a1 1 0 0 0-1.352 1.473l3.2 2.939a1 1 0 0 0 1.457-.112l4.8-6a1 1 0 0 0-1.562-1.25z"
        fill="#0061D5"
      />
      <rect
        fill="#FFF"
        height="86"
        rx="1.5"
        stroke="#0061D5"
        strokeWidth="2"
        width="57"
        x="82"
        y="68"
      />
      <path
        d="M114.003 103c5.428 0 9.845 4.325 9.993 9.72l.004.28c0 5.523-4.486 10-9.997 10H40.997C35.476 123 31 118.524 31 113c0-5.523 4.486-10 9.997-10h73.006zm-68.784 6.375l-4.131 5.164-2.412-2.214a1 1 0 1 0-1.352 1.473l3.2 2.939a1 1 0 0 0 1.457-.112l4.8-6a1 1 0 1 0-1.562-1.25z"
        fill="#0061D5"
      />
      <rect
        fill="#FFF"
        height="86"
        rx="1.5"
        stroke="#0061D5"
        strokeWidth="2"
        width="57"
        x="93"
        y="46"
      />
      <path
        d="M106 58.493A1.5 1.5 0 0 1 107.507 57h47.347c.832 0 1.93.53 2.444 1.175l11.765 14.75c.517.649.937 1.846.937 2.678v65.894c0 .83-.675 1.503-1.503 1.503h-60.994c-.83 0-1.503-.667-1.503-1.493V58.493z"
        fill="#FFF"
        stroke="#0061D5"
        strokeWidth="2"
      />
      <rect fill="#0061D5" height="2" rx="1" width="42" x="116" y="92" />
      <rect fill="#0061D5" height="2" rx="1" width="43" x="116" y="98" />
      <rect fill="#0061D5" height="2" rx="1" width="26" x="116" y="104" />
      <rect fill="#0061D5" height="2" rx="1" width="9" x="145" y="104" />
      <path
        d="M82 93H61c-4.418 0-8-3.134-8-7s3.582-7 8-7h21"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M108 124.95c0-.828.625-1.265 1.434-1.032 0 0 2.517 1.504 18.233 1.504 9.77 0 14.1 4.127 19.666 4.127 11.256 0 18.416-5.288 18.416-5.288.69-.447 1.251-.14 1.251.688v13.553c0 .827-.663 1.498-1.503 1.498h-55.994a1.5 1.5 0 0 1-1.503-1.498V124.95z"
        fill="#E5EFFA"
      />
      <path
        d="M168 73h-11.739A2.264 2.264 0 0 1 154 70.739V59"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M77 79h34.5a3.5 3.5 0 1 1 0 7H69"
        stroke="#0061D5"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <rect fill="#0061D5" height="2" rx="1" width="14" x="68" y="72" />
    </g>
  </AccessibleSVG>
);

export default SuccessFormIcon;
